export enum CreatorCoinTab {
  Buy = "buy",
  Sell = "sell",
  Transfer = "transfer",
  Lock = "lock",
  Burn = "burn",
}
